import Http from "./Http";

export class PayPalService extends Http {
  /**
   * Link user to PayPal
   * @param {Object} params
   * @param {string} params.authCode
   */
  connectPayPal(params) {
    return this.post("/paypal", params);
  }

  /**
   * Disconnect PayPal from user
   */
  disconnectPayPal() {
    return this.delete("/paypal");
  }
}

export default new PayPalService();
